var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "mount-custom-borders" } },
    [
      _c(
        "b-row",
        { attrs: { "align-h": "center" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "auto" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Top:", state: _vm.validity.top } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { append: "mm" } },
                    [
                      _c("b-form-input", {
                        attrs: { state: _vm.validity.top },
                        on: {
                          input: function ($event) {
                            return _vm.onLengthChange("top")
                          },
                        },
                        model: {
                          value: _vm.selectedBorders.top,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedBorders, "top", $$v)
                          },
                          expression: "selectedBorders.top",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Left:", state: _vm.validity.left } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { append: "mm" } },
                    [
                      _c("b-form-input", {
                        attrs: { state: _vm.validity.left },
                        on: {
                          input: function ($event) {
                            return _vm.onWidthChange("left")
                          },
                        },
                        model: {
                          value: _vm.selectedBorders.left,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedBorders, "left", $$v)
                          },
                          expression: "selectedBorders.left",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { lg: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Right:", state: _vm.validity.right } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { append: "mm" } },
                    [
                      _c("b-form-input", {
                        attrs: { state: _vm.validity.right },
                        on: {
                          input: function ($event) {
                            return _vm.onWidthChange("right")
                          },
                        },
                        model: {
                          value: _vm.selectedBorders.right,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedBorders, "right", $$v)
                          },
                          expression: "selectedBorders.right",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { attrs: { "align-h": "center" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "auto" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Bottom:", state: _vm.validity.bottom } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { append: "mm" } },
                    [
                      _c("b-form-input", {
                        attrs: { state: _vm.validity.bottom },
                        on: {
                          input: function ($event) {
                            return _vm.onLengthChange("bottom")
                          },
                        },
                        model: {
                          value: _vm.selectedBorders.bottom,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedBorders, "bottom", $$v)
                          },
                          expression: "selectedBorders.bottom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }